import {
	SET_AUDIOS,
	SET_AUDIO,
	CLEAR_AUDIOS,
	CLEAR_AUDIO,
	ADD_AUDIO,
	UPDATE_AUDIO,
	REMOVE_AUDIO,
} from './actionTypes';

export const audio = (state = true, action) => {
	switch (action.type) {
		case SET_AUDIO:
			return action.payload;
		case UPDATE_AUDIO:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_AUDIO:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_AUDIOS:
			return action.payload;
		case ADD_AUDIO:
			return [...state, action.payload];
		case UPDATE_AUDIO:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_AUDIO:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_AUDIOS:
			return [];
		default:
			return state;
	}
};
